/**
 * WordPress Data Store for TopBuddy UI Interactions
 * 
 * Manages UI state like active tab and expanded component
 * 
 * @package TopBuddy
 */

import { createReduxStore, register } from '@wordpress/data';

const STORE_NAME = 'topbuddy/ui';

const DEFAULT_STATE = {
	requestedTab: null,
	expandedComponentId: null,
	expandedPreviewComponentId: null,
};

const actions = {
	requestTabSwitch(tabName) {
		return {
			type: 'REQUEST_TAB_SWITCH',
			tabName,
		};
	},
	clearTabRequest() {
		return {
			type: 'CLEAR_TAB_REQUEST',
		};
	},
	setExpandedComponent(componentId) {
		return {
			type: 'SET_EXPANDED_COMPONENT',
			componentId,
		};
	},
	clearExpandedComponent() {
		return {
			type: 'CLEAR_EXPANDED_COMPONENT',
		};
	},
	openComponentSettings(componentId) {
		return {
			type: 'OPEN_COMPONENT_SETTINGS',
			componentId,
		};
	},
	openSettingsTab() {
		return {
			type: 'OPEN_SETTINGS_TAB',
		};
	},
	setExpandedPreviewComponent(componentId) {
		return {
			type: 'SET_EXPANDED_PREVIEW_COMPONENT',
			componentId,
		};
	},
	clearExpandedPreviewComponent() {
		return {
			type: 'CLEAR_EXPANDED_PREVIEW_COMPONENT',
		};
	},
};

const reducer = (state = DEFAULT_STATE, action) => {
	switch (action.type) {
		case 'REQUEST_TAB_SWITCH':
			return {
				...state,
				requestedTab: action.tabName,
			};
		case 'CLEAR_TAB_REQUEST':
			return {
				...state,
				requestedTab: null,
			};
		case 'SET_EXPANDED_COMPONENT':
			return {
				...state,
				expandedComponentId: action.componentId,
			};
		case 'CLEAR_EXPANDED_COMPONENT':
			return {
				...state,
				expandedComponentId: null,
			};
		case 'OPEN_COMPONENT_SETTINGS':
			return {
				...state,
				expandedPreviewComponentId: action.componentId,
			};
		case 'OPEN_SETTINGS_TAB':
			return {
				...state,
				requestedTab: 'settings',
			};
		case 'SET_EXPANDED_PREVIEW_COMPONENT':
			return {
				...state,
				expandedPreviewComponentId: action.componentId,
			};
		case 'CLEAR_EXPANDED_PREVIEW_COMPONENT':
			return {
				...state,
				expandedPreviewComponentId: null,
			};
		default:
			return state;
	}
};

const selectors = {
	getRequestedTab(state) {
		return state.requestedTab;
	},
	getExpandedComponentId(state) {
		return state.expandedComponentId;
	},
	getExpandedPreviewComponentId(state) {
		return state.expandedPreviewComponentId;
	},
};

const store = createReduxStore(STORE_NAME, {
	reducer,
	actions,
	selectors,
});

// Only register if not already registered
if (!window.wp.data.select(STORE_NAME)) {
	register(store);
}

export default store;
